import { render, staticRenderFns } from "./UserConsultancy.vue?vue&type=template&id=7c9c3c89&scoped=true"
import script from "./UserConsultancy.vue?vue&type=script&lang=js"
export * from "./UserConsultancy.vue?vue&type=script&lang=js"
import style0 from "./UserConsultancy.vue?vue&type=style&index=0&id=7c9c3c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9c3c89",
  null
  
)

export default component.exports